import { Select } from "antd"
import React, { useEffect, useState } from "react"
import { useCollection } from "../../hooks/useCollection"

export default function Manufacturers({ value, setValue }) {
  //manufacturers data form db
  const [allManufacturers, setAllManufacturers] = useState()

  //fetches manufacturers data
  const { data: manufacturersData, loading: manufacturersLoading } = useCollection("manufacturers")

  //sets the data of the manufacturers
  useEffect(() => {
    setAllManufacturers(manufacturersData)
  }, [manufacturersData])

  //updates state
  const handleChange = (value, option) => {
    setValue(option)
    console.log(option)
  }

  //select style
  const style = { width: "100%" }

  return (
    <>
      <Select
        showSearch
        loading={manufacturersLoading}
        fieldNames={{ value: "company", label: "company" }}
        value={value && { value: value.company, label: value.company }}
        onChange={handleChange}
        style={style}
        placeholder="Select manufacturer"
        optionFilterProp="children"
        filterOption={(input, option) =>
          (option?.company ?? "").toLowerCase().includes(input.toLowerCase())
        }
        options={allManufacturers}
      />
    </>
  )
}
